"use strict";

coronaService.$inject = ["api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.coronaService = coronaService;
/*@ngInject*/
function coronaService(api) {
    return {
        setCoronaReservation: setCoronaReservation,
        getCorona: getCorona,
        vaccinsCanOrder: vaccinsCanOrder,
        canOrderVaccin: canOrderVaccin,
        allReservationsMade: allReservationsMade,
        isEnabled: isEnabled
    };

    function getCorona() {
        return api.coronaReservation.get({}).$promise.then(function (resource) {
            return resource.reservations;
        });
    }

    function vaccinsCanOrder(vaccins) {
        var vaccin = vaccins.find(function (vaccin) {
            return vaccin.amount > 0;
        });
        return vaccin === undefined ? false : true;
    }

    function allReservationsMade(vaccins) {
        return vaccins.every(amountNotZero);
    }

    function amountNotZero(vaccin) {
        return vaccin.amount !== 0;
    }

    function canOrderVaccin(vaccin) {
        return vaccin.amount === 0;
    }

    function setCoronaReservation(vaccines) {
        var vaccinesPost = [];

        vaccines.forEach(function (vaccine) {
            vaccinesPost.push({
                productNumber: vaccine.productNumber,
                amount: vaccine.amount
            });
        });

        return api.setReservationAmounts.set({
            reservations: vaccinesPost
        }).$promise.then(function (resources) {
            return resources;
        });
    }

    function isEnabled() {
        return api.enabled.get({}).$promise.then(function (resource) {
            return resource;
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/coronaService.js
// module id = 808
// module chunks = 0